module.exports = __webpack_public_path__ + "linea-software-10.8fe30102fca386ab297c.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-software-10.ttf
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-software-10.ttf
// module chunks = styles